if (!customElements.get('product-content')) {
  customElements.define('product-content', class ProductContent extends HTMLElement {
    constructor() {
      super();
      this.handleBuyTools();
      this.handleCollapsibleBlocks();
    }

    handleBuyTools() {
      const productPageSection = document.querySelector('.product-page-section');
      if (!productPageSection) return;

      const isWrapped = productPageSection.closest('.product-section-main-wrap');
      const productInformation = productPageSection.querySelector('product-information');
      const productInfoWraper = productPageSection.querySelector('.product__info-wrapper');
      const nextElement = productPageSection ? productPageSection.nextElementSibling : null;
      const productContentIsNextSibling = nextElement ? nextElement.classList.contains('product-content-section') : false;

      if (productInfoWraper && productContentIsNextSibling) {
        if (!isWrapped) {
          const templateProduct = this.closest('.template-product-wrapper');
          const walletButton = templateProduct ? templateProduct.querySelector('.wallet-button-fade-in') : null;
          if (walletButton) walletButton.innerHTML = '';
          $('.product-section').wrapAll('<div class="product-section-main-wrap" />');
        }

        productPageSection.classList.remove('product-static-buy-tools');

        if (productInformation) {
          productInformation.buyToolsCalculations();
          window.addEventListener('scroll', productInformation.onScrollToolsHandler, false);
        }
      } else if (productInfoWraper && !productContentIsNextSibling) {
        productPageSection.classList.add('product-static-buy-tools');
        if (productInformation) {
          window.removeEventListener('scroll', productInformation.onScrollToolsHandler, false);
          productInformation.staticBuyTools = true;
        }
      }
    }

    handleCollapsibleBlocks() {
      this.accordionStates = new Map();
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onAccordionClick = event => {
        const summary = event.target.closest('summary');
        const detail = summary?.parentElement;
        const state = this.accordionStates.get(detail);
        if (!state || summary !== state.summary || event.defaultPrevented) return;
        if (event.target.closest('a, button, input, select, textarea')) return;
        event.preventDefault();
        this.animateAccordion(detail, state, !state.desired);
      };
      this.onMotionChange = () => {
        if (this.motionPreference.matches) {
          this.accordionStates.forEach((state, detail) => this.finishAccordion(detail, state));
        }
      };
      this.contentObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
          const detail = entry.target.closest('.product__collapsible-details');
          const state = this.accordionStates.get(detail);
          if (!state || entry.target !== state.content) return;
          const size = entry.target.getBoundingClientRect();
          const changed = Math.abs(size.height - state.contentHeight) > 1 || Math.abs(size.width - state.contentWidth) > 1;
          if (state.animation && state.desired && changed) this.animateAccordion(detail, state, true);
          state.contentHeight = size.height;
          state.contentWidth = size.width;
        });
      });

      this.querySelectorAll('.product__collapsible-details').forEach(detail => {
        const summary = detail.querySelector(':scope > summary');
        const content = detail.querySelector(':scope > .product__collapsible__content');
        if (!summary || !content) return;
        const size = content.getBoundingClientRect();
        const state = {
          summary, content, desired: detail.open, animation: null, contentAnimation: null,
          initialHeight: detail.style.getPropertyValue('height'),
          initialHeightPriority: detail.style.getPropertyPriority('height'),
          initialInert: content.inert,
          contentHeight: size.height, contentWidth: size.width
        };
        state.onToggle = () => {
          if (state.animation && detail.open) return;
          if (state.animation) this.finishAccordion(detail, state, detail.open);
          state.desired = detail.open;
          detail.dataset.pcOpen = String(detail.open);
          summary.setAttribute('aria-expanded', String(detail.open));
        };
        detail.dataset.pcOpen = String(detail.open);
        summary.setAttribute('aria-expanded', String(detail.open));
        detail.addEventListener('toggle', state.onToggle);
        this.accordionStates.set(detail, state);
        this.contentObserver.observe(content);
      });
      this.addEventListener('click', this.onAccordionClick);
      this.motionPreference.addEventListener('change', this.onMotionChange);
    }

    animateAccordion(detail, state, desired) {
      const height = detail.getBoundingClientRect().height;
      const wasOpen = detail.open;
      const contentStyle = getComputedStyle(state.content);
      const opacity = wasOpen ? contentStyle.opacity : '0';
      const transform = wasOpen ? contentStyle.transform : 'translateY(-4px)';
      this.cancelAccordionAnimations(state);
      state.desired = desired;
      detail.dataset.pcOpen = String(desired);
      state.summary.setAttribute('aria-expanded', String(desired));
      if (!desired && state.content.contains(document.activeElement)) state.summary.focus({ preventScroll: true });
      state.content.inert = desired ? state.initialInert : true;

      if (this.motionPreference.matches || typeof detail.animate !== 'function') {
        this.finishAccordion(detail, state);
        return;
      }

      detail.open = true;
      detail.style.height = 'auto';
      const detailStyle = getComputedStyle(detail);
      const border = parseFloat(detailStyle.borderTopWidth) + parseFloat(detailStyle.borderBottomWidth);
      const endHeight = desired ? detail.getBoundingClientRect().height : state.summary.getBoundingClientRect().height + border;
      const contentSize = state.content.getBoundingClientRect();
      state.contentHeight = contentSize.height;
      state.contentWidth = contentSize.width;
      const mobile = window.matchMedia('(max-width: 768px)').matches;
      const configuredDuration = parseFloat(detailStyle.getPropertyValue('--pc-motion-duration'));
      const duration = Number.isFinite(configuredDuration) ? configuredDuration : mobile ? 260 : 300;
      detail.style.height = `${height}px`;
      const animation = detail.animate([
        { height: `${height}px` }, { height: `${endHeight}px` }
      ], { duration, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' });
      state.animation = animation;
      state.contentAnimation = state.content.animate([
        { opacity, transform },
        { opacity: desired ? '1' : '0', transform: desired ? 'translateY(0)' : 'translateY(-4px)' }
      ], { duration: duration * (desired ? 0.9 : 0.75), easing: 'ease-out', fill: 'both' });
      animation.onfinish = () => {
        if (state.animation === animation) this.finishAccordion(detail, state);
      };
    }

    cancelAccordionAnimations(state) {
      if (state.animation) {
        state.animation.onfinish = null;
        state.animation.cancel();
        state.animation = null;
      }
      if (state.contentAnimation) {
        state.contentAnimation.cancel();
        state.contentAnimation = null;
      }
    }

    finishAccordion(detail, state, desired = state.desired) {
      state.desired = desired;
      detail.open = desired;
      this.cancelAccordionAnimations(state);
      if (state.initialHeight) detail.style.setProperty('height', state.initialHeight, state.initialHeightPriority);
      else detail.style.removeProperty('height');
      state.content.inert = state.initialInert;
      detail.dataset.pcOpen = String(desired);
      state.summary.setAttribute('aria-expanded', String(desired));
    }

    connectedCallback() {
      if (this.accordionDisconnected) {
        this.accordionDisconnected = false;
        this.handleCollapsibleBlocks();
      }
    }

    disconnectedCallback() {
      if (!this.accordionStates) return;
      this.contentObserver.disconnect();
      this.removeEventListener('click', this.onAccordionClick);
      this.motionPreference.removeEventListener('change', this.onMotionChange);
      this.accordionStates.forEach((state, detail) => {
        this.finishAccordion(detail, state);
        detail.removeEventListener('toggle', state.onToggle);
      });
      this.accordionStates.clear();
      this.accordionDisconnected = true;
    }
  });
}
